import { mapDepartment } from '@webapp/core/data-access/mappers/mapDepartment'
import { type OrderItemAccountApiModel } from '../api-models/OrderItemAccountApiModel'

export const mapOrderItemAccount = (accountData: OrderItemAccountApiModel) => {
  return {
    accountCode: {
      id: accountData.account_code.id,
      active: accountData.account_code.active,
      code: accountData.account_code.code,
      description: accountData.account_code.description,
      type: accountData.account_code.account_type,
    },
    id: accountData.id,
    active: accountData.active,
    secondaryCategory: mapDepartment(accountData.department),
  }
}
